var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xu-qiu-lei-bie"},[_c('dv-border-box-11',{attrs:{"title":"质量服务需求类别统计","titleWidth":250}},[_c('div',{ref:"xu_qiu_lei_bie_echarts",staticClass:"xu-qiu-lei-bie-container"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }